import {Injectable} from "@angular/core";
import { DateParams, ExperimentMap, FilterParams, RefExtendedParams } from "app/models/filter_form.model";

import merge from "lodash-es/merge";
import omitBy from "lodash-es/omitBy";
import isEqual from "lodash-es/isEqual";
import isObject from "lodash-es/isObject";

import * as moment from 'moment-timezone';
import * as qs from 'clever-qs';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {HttpClient} from "@angular/common/http";
import { mergeFilterParams } from "../../lib/lib";
import {GroupRefService} from "../../support/group_ref/group_ref.service";

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataProvider2, DataRequest } from "../../provider/data2.provider";
import { IStatResult } from "../../models/responce_result.model";

interface ReportQueryHistory {
	
}

interface ReportQueryHistoryResult {
	queries: ReportQueryHistory[];
}


@Injectable()
export class FilterFormService {
	public filterParams: FilterParams = new FilterParams();
	public defaultFilterParams: FilterParams = new FilterParams();
	public addFilterParams: FilterParams = new FilterParams();
	public experimentMap: ExperimentMap = new ExperimentMap();
	public filterPanelParams: any;
	public currentUrl: string;
	private _reportGUID: string;
	
	public addFilters:string[] = [];
	
	readonly excludeKeys: string[] = [ 'dateType', 'trialStart', 'trialEnd' ];
	public refererTypes = ['first', 'created', 'last', 'paid'];
	public refExtendedFilterOperators = [
		'equal', 'contains', 'starts', 'ends',
		'regexp', 'empty', 'not equal', 'not contains', 'not start',
		'not end', 'not regexp', 'not empty'
	];

	public refGroups = [];

	public refGroupList = [];

	public refSourceList = [];

	public promocode: DataRequest;
	
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private _translate: TranslateService,
		public http: HttpClient,
		public groupRef: GroupRefService,
		public dp2: DataProvider2,
	) {
		
	}
	
	async getData() {
		const me = this;
		
		me.refGroups = await me.groupRef.getGroups().toPromise();

		me.refGroupList = await me.getRefGroupFilterList();

		const refGroup = me.filterParams.refGroup;
		if (refGroup && refGroup !== 'all') {
			const group = me.refGroups.find(g => g.name === refGroup);

			const refSourceList = await me.groupRef.getSources(group.id).toPromise();
			me.refSourceList = refSourceList.map(s => s.name);
		}
	}
	
	setAddFilterParams(addParams: FilterParams) {
		const me = this;
		
		me.addFilterParams = addParams;
		
		me.activatedRoute.queryParams.subscribe(() => {
			const params = qs.parse(me.router.url.split('?')[1]);
			
			// Смерджить дефолты, доп. параметры отчёта и urlHash.
			me.filterParams = merge({}, me.defaultFilterParams, me.addFilterParams);
			
			me.filterParams = merge({}, me.filterParams, params);
			
			Object.keys(me.experimentMap).forEach(function(key) {
				if (me.filterParams[key] != '') {
					me.filterParams.experimentName  = key;
					me.filterParams.experimentValue = me.filterParams[key];
				}
			});
			
			me.filterParams.dateFilterParams = me.getDateFilterParams(me.filterParams, me.addFilterParams);
			
			me.renderFilterTags(merge({}, me.addFilterParams, params));
			
			me.currentUrl = me.router.url;
		});
	}
	
	
	getPromocodeList(fp): Observable<IStatResult> {
		return this.dp2.get<IStatResult>('/promocode/list', fp);
	}
	
	
	/**
	 * 
	 * @param {FilterParams} params
	 * @returns {FilterParams}
	 */
	getDiffParams(params: FilterParams): FilterParams {
		let me                  = this,
			defaultFilterParams = me.defaultFilterParams;
		
		// Оставить только параметры, отличные от дефолтных
		let diff = omitBy(params, (v, k) => defaultFilterParams[k] === v);
		
		// Дополнительная проверка для объектов
		Object.keys(diff).forEach(function (key) {
			if (isObject(diff[key])) {
				if (isEqual(defaultFilterParams[key], diff[key])) {
					delete diff[key];
				}
			}
		});
		
		return <FilterParams>diff;
	}
	
	
	getDateFilterParams(params: FilterParams, addFilterParams: FilterParams) {
		// Не знаю почему массив нормально не мерджится
		if (addFilterParams.dateFilters) {
			params.dateFilters = addFilterParams.dateFilters;
		}
		
		params.dateFilters.forEach(function (type) {
			if (typeof params.dateFilterParams[type] === 'undefined') {
				params.dateFilterParams[type] = {
					start: '',
					end: '',
					type: 'all'
				};
			}
		});
		
		return params.dateFilterParams;
	}
	
	
	getApplyFilters(filterParam: FilterParams): any {
		let me           = this,
			otherFilters = {};
		
		/** otherFilters
		 * Проход по addFilterParams и поиск изменений в текущих фильтрах.
		 * Если текущий фильтр отличается от этого же фильтра, заданного в addFilterParams, то потом надо его намерджить после всех манипуляций.
		 * Иначе изменения будут затерты настройками из addFilterParams.
		 * 
		 * Связано с проблемой, когда не могли установить фильтр на userType = all в отчётах (например reg_day).
		 */
		
		
		Object.keys(this.addFilterParams).forEach(function(el) {
			if (filterParam[el] != me.addFilterParams[el]) {
				otherFilters[el] = filterParam[el]; 
			}
		});
		
		let params: FilterParams = merge({}, this.getDiffParams(filterParam), otherFilters);
		
		if (params.dateFilterParams) {
			Object.keys(params.dateFilterParams).forEach(function(dateType) {
				if (params.dateFilterParams[dateType].type != 'all' && params.dateFilterParams[dateType].type != 'other') {
					let dateParams: DateParams = me.filterBuilder(params.dateFilterParams[dateType].type);
					
					params.dateFilterParams[dateType] = {
						start : dateParams.start || '',
						end   : dateParams.end || '',
						type  : params.dateFilterParams[dateType].type
					};
				} else if (params.dateFilterParams[dateType].type == 'all') {
					delete params.dateFilterParams[dateType];	
				}
			});
		}
		
		delete params.dateFilters;
		delete params.isRegDay;
		delete params.isBilling;
		delete params.isDomainBilling;
		delete params.isTemplateTag;
		delete params.isExpiredPaid;
		delete params.isPromocode;
		delete params.isExpiredDomains;
		delete params.isNotice;
		delete params.experimentName;
		delete params.experimentValue;
		delete params.dateTime;

		if (params.refGroup) {
			params.refGroup = encodeURIComponent(params.refGroup);
		}

		if (params.refSource) {
			params.refSource = encodeURIComponent(params.refSource);
		}
		
		return params;
	}
	
	
	_a(key: string) {
		return this._translate.instant('adminstat.' + key);
	}
	
	
	// Вывести список активных фильтров
	renderFilterTags(_params: FilterParams) {
		const me = this;
		
		this.filterPanelParams = {};
		
		const params = merge({}, _params);
		
		delete params.allowList;
		delete params.dateFilters;
		delete params.isRegDay;
		delete params.isBilling;
		delete params.isTemplateTag;
		delete params.isExpiredPaid;
		delete params.isPromocode;
		delete params.isAccessor;
		delete params.isBillingAllow;
		delete params.isDomainBilling;
		delete params.refererFilterType;
		delete params.dateType;
		
		Object.keys(params).forEach(function(key) {
			if (me.excludeKeys.includes(key)) {
				return true;
			}
			
			if (key === 'refExtendedFilters') {
				me.filterPanelParams[me._a('filterForm.' + key)] = '';
				
				params[key].forEach(function(rule) {
					if ( ! rule.condition && rule.refererType) {
						me.filterPanelParams[me._a('filterForm.' + key)] +=  me._a('filterForm.' + rule.refererType) + ' - ' + rule.searchByMarkUtm + ' ' + me._a('users.group_ref_new.' + rule.searchByMarkRule) + ' ' + rule.refererSearchValue;
					} else {
						me.filterPanelParams[me._a('filterForm.' + key)] += ' ' + me._a('filterForm.' + rule.condition) + ' ';
					}
				});
			} else if (key === 'dateFilterParams') {
				Object.keys(params[key]).forEach(function(dateFilter) {
					me.filterPanelParams[me._a('filterForm.' + dateFilter)] =  params[key][dateFilter].start + ' - ' + params[key][dateFilter].end;
					
					if (params[key][dateFilter].type != 'other') {
						me.filterPanelParams[me._a('filterForm.' + dateFilter)] += ' (' + me._a('common.interval.' + params[key][dateFilter].type) + ')';
					}
				});
			} else if (key == 'addedWidget' || key == 'actionCount' || key == 'promoProgress') {
				me.filterPanelParams[me._a('filterForm.' + key)] = me._a('filterForm.start') + ' ' + me._a('filterForm.' + params[key].gt) + ' - ' + me._a('filterForm.end') + ' ' + me._a('filterForm.' + params[key].lt);
			} else if (typeof params[key] == 'number' || key == 'domainZone' || key == 'email' || key == 'emailOther' || key == 'regFilter' || key == 'subject' || key == 'category' || key == 'serverAlias' || key === 'realSubject') {
				me.filterPanelParams[me._a('filterForm.' +  key)] = params[key];
			} else if (key == 'refUrl') {
				me.filterPanelParams[me._a('filterForm.' +  key)] = params[key];
			} else if (key === 'paidStatus') {
				let str = '';
				
				if (params.paidStatus === 'trial') {
					const
						{ trialStart, trialEnd } = params,
						label                    = me._a('filterForm.trial day'),
						startLabel               = me._a('filterForm.start'),
						endLabel                 = me._a('filterForm.end');
					
					if (trialStart && trialEnd) {
						str = `${label} ${startLabel} ${trialStart} ${endLabel} ${trialEnd}`;
					} else if (trialStart) {
						str = `${label} ${startLabel} ${trialStart}`;
					} else if (trialEnd) {
						str = `${label} ${endLabel} ${trialEnd}`;
					} else {
						str = me._a('filterForm.paidStatusList.' + params[key]);
					}
				} else {
					str = me._a('filterForm.paidStatusList.' +  params[key]);
				}
				me.filterPanelParams[me._a('filterForm.' +  key)] = str;
			} else if (key === 'source') {
				me.filterPanelParams[me._a('common.' +  key)] = me._a('common.clusters.' +  params[key]);
			} else if (key === 'page') {
				me.filterPanelParams[me._a('filterForm.' +  key)] = params[key];
			} else if (key === 'lang') {
				me.filterPanelParams[me._a('filterForm.' +  key)] = params[key];
			} else {
				me.filterPanelParams[me._a('filterForm.' +  key)] = me._a('filterForm.' +  params[key]);
			}
		});
		
		delete this.filterPanelParams.allowList;
		delete this.filterPanelParams.dateFilters;
		delete this.filterPanelParams.isRegDay;
		delete this.filterPanelParams.isBilling;
		delete this.filterPanelParams.isTemplateTag;
		delete this.filterPanelParams.isExpiredPaid;
		delete this.filterPanelParams.isPromocode;
		delete this.filterPanelParams.isAccessor;
		delete this.filterPanelParams.isBillingAllow;
		delete this.filterPanelParams.isDomainBilling;
		delete this.filterPanelParams.refererFilterType;
		delete this.filterPanelParams.dateType;
	}
	
	
	filterBuilder(type: string): any {
		let milisecByDay = 24 * 3600 * 1000;
		let query      = {};
		
		let start      = new Date();
		let end        = new Date();
		
		if (type) {
			switch (type) {
				case 'all':
					start = null;
					end   = null;
					break;
				case 'yesterday':
					end   = moment(new Date()).date(moment(new Date()).date() - 1).toDate();
					start = moment(end).toDate();
					
					break;
				case 'now':
					end = new Date();
					start = new Date();
					
					break;
				case 'last7day':
					end = new Date();
					start = moment(end.getTime() - 7 * milisecByDay).toDate();
					
					break;
				case 'last30day':
					end = new Date();
					start = moment(end.getTime() - 30 * milisecByDay).toDate();
					
					break;
				case 'prevWeek':
					end = moment(new Date()).subtract(1, 'weeks').endOf('isoWeek').toDate();
					start = moment(end).subtract(0, 'weeks').startOf('isoWeek').toDate();
					
					break;
				case 'prevMonth':
					end = moment(new Date()).subtract(1, 'months').endOf('month').toDate();
					start = moment(end).subtract(0, 'months').startOf('month').toDate();
					
					break;
				case 'allTime':
					end = moment().endOf('day').toDate();
					start = moment('2015-03-01 00:00:00').toDate();
					
					break;
				case 'other':
					if (moment(end, "DD-MM-YYYY").isValid()) {
						end = moment(end, "DD-MM-YYYY").toDate();
					} else {
						end = new Date();
					}
					
					if (moment(start, "DD-MM-YYYY").isValid()) {
						start = moment(start, "DD-MM-YYYY").toDate();
					} else {
						start = new Date();
					}
					
					break;
				default:
					// 1;
					break;
			}
			
			if (start && end) {
				// Не выравниваем границу дня для "предыдущая неделя" и " предыдущий месяц"
				if (['lastWeek', 'lastMonth'].indexOf(type) > -1) {
					query['start'] = moment(start).format("DD-MM-YYYY");
					query['end'] = moment(end).format("DD-MM-YYYY");
				} else {
					query['start'] = moment(start).startOf('day').format("DD-MM-YYYY");
					query['end'] = moment(end).endOf('day').format("DD-MM-YYYY");
				}
			}
		} else {
			delete query['start'];
			delete query['end'];
		}
		
		return query;
	}
	
	
	getFilterParams() {
  		return this.filterParams;
	}
	
	
	getCopyFilterParams(params?: FilterParams) {
		return mergeFilterParams(this.filterParams, params);
	}
	
	
	getDatesFilter(dateType: string, borderName?: string) {
		const dateFilter = this.filterParams.dateFilterParams[dateType] || {};
		
		if (borderName) {
			return dateFilter[borderName];
		}
		
		return dateFilter;
	}
	
	
	getCityList(ccode: string = 'ru', searchQuery?: string) {
		const params = { ccode };
		
		if (searchQuery) {
			params['searchQuery'] = searchQuery;
		}
		
		return this.dp2.get('/cities', params);
	}
	
	
	async getRefGroupFilterList() {
		const refGroupList = await this.groupRef.getGroups().toPromise();
		return [ 'all', 'Direct', 'Referral', 'Ungrouped', ...refGroupList.map(g => g.name) ];
	}
	
	
	async getRefSourceFilterList(refGroup: string) {
		const me = this;

		const refGroups = await me.groupRef.getGroups().toPromise();
		
		const group = refGroups.find(g => g.name === refGroup);
		
		const refSourceList = await me.groupRef.getSources(group.id).toPromise();
		
		return refSourceList.map(s => s.name);
	}
	
	setReportGUID() {
		this._reportGUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
	
	get reportGUID():string {
		if (!this._reportGUID) {
			this.setReportGUID();
		}

		return this._reportGUID;
	}

	getReportQueries(): Observable<ReportQueryHistoryResult> {
		return this.dp2.get(`/report_queries/${this._reportGUID}`).pipe(
			map(r => <ReportQueryHistoryResult>r)
		);
	}

	changeRefererType(type: string) {
		const me = this;
		
		if (type == me.filterParams.refererFilterType) {
			return true;
		}

		me.filterParams.refererFilterType = type;

		if (type == 'extended') {
			me.filterParams.refGroup  = 'all';
			me.filterParams.refSource = 'all';

			me.filterParams.refExtendedFilters.push(<RefExtendedParams>{
				refererType: me.filterParams.refererType || 'first',
				searchByMarkUtm: 'utm_source',
				searchByMarkRule: 'equal',
				refererSearchValue: ''
			});
		} else if (type == 'simple') {
			me.filterParams.refExtendedFilters = [];
		}
	}


	async onRefGroupSelect(refGroup: string) {
		this.refSourceList = await this.getRefSourceFilterList(refGroup);
	}
	
	
	reset() {
		this.filterParams = new FilterParams();
		this.filterParams = merge({}, this.filterParams, this.addFilterParams);
		this.filterParams.dateFilterParams = this.getDateFilterParams(this.filterParams, this.addFilterParams);
	}
}
